performance.mark('configure:init');

// We are using console in production for time tests.
// IE doesn't support console in all cases so we're
// writing this to prevent errors in IE.
if (!window.console) {
  window.console = {
    error() { },
    log() { },
    time() { },
    timeEnd() { },
    warn() { }
  };
}

window.configureInstanceVersion = () => {
  return {
    version: process.env.version,
    buildDate: process.env.build_date,
    commitHash: process.env.commit_hash,
    'imp-tools-build': process.env.imp_tools_build
  };
};

if (!window.console.time) {
  window.console.time = function () { };
  window.console.timeEnd = function () { };
}

console.time('Load Configure JavaScript');

const globalBuild = require('@fluid.inc/imp-ui-helpers').globalBuild();
const _ = require('lodash');

// Set the initialization parameters
const params = {
  'workflow': process.env.workflow,
  'customer': process.env.customer_id,
  'loc': globalBuild.loc,
  'buildType': process.env.build_type,
  'environment': 'prod',
  'product': _.toInteger(process.env.product_id),
  'facebookAppId': 693861180706239
};

// Load in Google Analytics
require('./utils/google_analytics')(_.merge(params, window.configureParams));
require('./utils/require-babel-polyfill.js');
fluidTimings.start('Load JavaScript');

(function () {

  const createDispatcher = require('./lib/dispatcher');
  const createActions = require('./actions/_actionIndex');
  const createStore = require('./stores/store');
  const utils = require('@fluid.inc/imp-ui-helpers').utils(params);
  const $ = require('jquery');

  console.time('Configure Loaded');
  console.time('Model Rendered');

  // get or create the _fluid initializer queue
  const _fluid = window._fluid = window._fluid || [],
    // Configure Params support
    configureParams = window.configureParams || {};
  // API reference
  let configure,
    // jQuery object for the #fluidConfigure container
    $container,
    // Application reference
    configureApp,
    // Merged params object
    mergedParams;

  function createConfigure(unavailable, recipeDocument) {
    if (mergedParams.workflow === 'dev' || mergedParams.workflow === 'qa') {
      window._configure = configure;
    }
    mergedParams.dtgUrls = {};
    const dispatcher = createDispatcher();
    const actions = utils.mapActions(createActions, dispatcher);
    const store = createStore(dispatcher);

    // Initialize the app
    const app = require('./components/app')(configure, mergedParams, $container, utils, globalBuild, dispatcher, store, actions, initConfigure); // eslint-disable-line no-use-before-define
    app.init(unavailable, recipeDocument);
  }

  function loadConfigure(err, Configure) {
    // Cache the configure HTML div
    $container = $('#fluidConfigure');

    // Cache the configure object
    configure = Configure;

    let unavailable = false;
    let recipeDocument = false;

    if (err) {
      if (err.fcErrorType === 'recipe:invalid' && err.fcErrorDetails) {
        unavailable = err.fcErrorDetails.unavailable;
        recipeDocument = err.fcErrorDetails.recipeDocument;

        configure.run('setFallbackRecipe', err.fcErrorDetails.fallbackRecipe, function (err) {
          if (err) { throw err; }

          // Globally disable the unavailable dialog per RAL-3400
          unavailable = false;

          createConfigure(unavailable, recipeDocument);
        });
      } else {
        throw err;
      }
    } else {
      createConfigure();
    }
  }

  function addUtmTags(url, shareType) {
    const utm_tags = {
      'utm_source': 'FluidCustom',
      'utm_medium': 'Social',
      'utm_campaign': shareType + 'Share'
    };

    _.forEach(utm_tags, function (tag, key) {
      if (url.indexOf(key) >= 0) {
        const regex = new RegExp('(' + key + '=).*?(&|$)', 'g');
        url = url.replace(regex, '$1' + tag + '$2');
      } else {
        // See if the URL has URL params
        const querySeparator = (url.indexOf('?') >= 0) ? '&' : '?';

        url = url + querySeparator + key + '=' + tag;
      }
    });

    return url;
  }

  function removeUUID(url) {
    return url.replace(/uuid=.*?(&|$)/g, '');
  }

  function getRecipeUrl(recipeId, shareType) {
    // Get the current URL:
    let url = document.referrer ? document.referrer : window.top.location.href;

    // If a recipe ID is already defined, replace the ID
    if (url.indexOf('recipeId') >= 0) {
      // Replace an existing recipe ID with the new one
      url = url.replace(/recipeId=[0-9]*/g, 'recipeId=' + recipeId);
    } else {
      // See if the URL has URL params
      const querySeparator = (url.indexOf('?') >= 0) ? '&' : '?';
      url = url + querySeparator + 'recipeId=' + recipeId;
    }
    return removeUUID(addUtmTags(url, shareType));
  }
  function normalizeLocale(passedLocale) {
    const mappings = {
      'de_AT': 'de_DE',
      'de_CH': 'de_DE',
      'de_DE': 'de_DE',
      'de_EE': 'de_DE',
      'de_FL': 'de_DE',
      'de_LV': 'de_DE',
      'de_SK': 'de_DE',
      'en_AT': 'en_GB',
      'en_BE': 'en_GB',
      'en_BG': 'en_GB',
      'en_CH': 'en_GB',
      'en_CY': 'en_GB',
      'en_CZ': 'en_GB',
      'en_DE': 'en_GB',
      'en_DK': 'en_GB',
      'en_EE': 'en_GB',
      'en_ES': 'en_GB',
      'en_FI': 'en_GB',
      'en_FR': 'en_GB',
      'en_GB': 'en_GB',
      'en_GR': 'en_GB',
      'en_HK': 'en_HK',
      'en_HR': 'en_GB',
      'en_HU': 'en_GB',
      'en_IR': 'en_GB',
      'en_IE': 'en_GB',
      'en_IT': 'en_GB',
      'en_LT': 'en_GB',
      'en_LU': 'en_GB',
      'en_LV': 'en_GB',
      'en_MT': 'en_GB',
      'en_NL': 'en_GB',
      'en_PL': 'en_GB',
      'en_PT': 'en_GB',
      'en_RO': 'en_GB',
      'en_SE': 'en_GB',
      'en_SI': 'en_GB',
      'en_SK': 'en_GB',
      'en_UK': 'en_GB',
      'en_US': 'en_us',
      'en_us': 'en_us',
      'es_ES': 'es_ES',
      'fr_BE': 'fr_FR',
      'fr_CH': 'fr_FR',
      'fr_FR': 'fr_FR',
      'fr_LU': 'fr_FR',
      'it_IT': 'it_IT',
      'nl_BE': 'nl_NL',
      'nl_NL': 'nl_NL'
    };
    let newLocale = passedLocale;
    if (typeof mappings[passedLocale] !== 'undefined') {
      newLocale = mappings[passedLocale];
    }
    return newLocale;
  }
  const getUiSharingSettings = () => ({
    shareFacebook: {
      recipeUrlTemplate: getRecipeUrl('{recipe_id}', 'Facebook')
    },
    shareTwitter: {
      recipeUrlTemplate: getRecipeUrl('{recipe_id}', 'Twitter')
    },
    shareEmail: {
      recipeUrlTemplate: getRecipeUrl('{recipe_id}', 'Email')
    },
    sharePinterest: {
      recipeUrlTemplate: getRecipeUrl('{recipe_id}', 'Pinterest')
    }
  });

  function initConfigure(params) {
    params.uiSettings = getUiSharingSettings();
    // Make sure the locale is added
    if (!mergedParams.locale) {
      mergedParams.locale = 'en_us';
    }
    if (params.productGraph && params.defaultUiSettings && typeof params.productGraph === 'string') {
      // If we are passing a productGraph, we should have the defaultUiSettings as well.
      // We will download those local files and pass them as data on the options when loading configure.
      const baseUrl = window.location.origin + window.location.pathname.replace('configurator.html', '');
      const productGraphUrl = baseUrl + params.productGraph;
      const promises = [];
      promises.push($.ajax({
        url: productGraphUrl,
        dataType: 'json'
      }));
      const uiSettingsUrl = baseUrl + params.defaultUiSettings;

      promises.push($.ajax({
        url: uiSettingsUrl,
        dataType: 'json'
      }));
      Promise.all(promises).then(function (data) {

        params.productGraph = data[0];
        params.defaultUiSettings = data[1];
        configureApp(params, loadConfigure);
      }).catch(function () {
        // we want to remove the passed params to avoid exceptions.
        params.productGraph = '';
        params.defaultUiSettings = '';
        configureApp(params, loadConfigure);
      });
    } else {
      // Load a configure API instance for a given product
      configureApp(params, loadConfigure);
    }
  }

  // Push an asynchronous handler that will receive a copy of the fluid runtime
  _fluid.push(function (err, fluid) {
    // Handle loading errors
    if (err) {
      throw err;
    }

    // The configure application constructor
    configureApp = fluid.apps.configure;

    // Mix the default params with configureParams then merge with the options from the URL
    mergedParams = _.merge(_.merge(params, configureParams), configureApp._GET);

    let localeFacet = 'US';
    if (mergedParams.locale) {
      mergedParams.requestedLocale = mergedParams.locale;
      mergedParams.locale = normalizeLocale(mergedParams.locale);
      const EU_LOCALES = ['en_GB', 'de_DE', 'it_IT', 'fr_FR', 'en_UK', 'es_ES', 'nl_NL'];
      const CHINA_LOCALES = ['zh_CN', 'en_HK'];
      const JAPAN_LOCALES = ['ja_JP'];
      if (EU_LOCALES.includes(mergedParams.locale)) {
        localeFacet = 'EU';
      } else if (CHINA_LOCALES.includes(mergedParams.locale)) {
        localeFacet = (mergedParams.requestedLocale === 'en_HK') ? 'HK' : 'ASIA';
      } else if (JAPAN_LOCALES.includes(mergedParams.locale)) {
        localeFacet = 'JP';
      } else {
        localeFacet = 'US';
      };

      if (mergedParams.fluidEnv && localeFacet === 'EU' && !_.has(mergedParams, 'Avail')) {
        let olaLocale = mergedParams.requestedLocale.replace('_', '-');
        const localePartial = olaLocale.split('-')[1].toLowerCase();
        let sterlingKey = 'RLEU_Sterling';

        if (localePartial === 'uk') {
          sterlingKey = 'RalphLauren_GB';
          olaLocale = 'en-GB';
        }

        mergedParams.Avail = (mergedParams.useProdFeed) ?
          `https://www.ralphlauren.eu/s/RLEU_Sterling/dw/shop/v17_7/products/( )?pretty_print=true&expand=availability,prices,variations&client_id=7422b4b7-e115-48b0-93bb-ba6dc8ee59fd&locale=${olaLocale}` :
          `https://development-${localePartial}-sterling.sfcc-ralphlauren-eu.com/s/${sterlingKey}/dw/shop/v17_7/products/( )?pretty_print=true&expand=availability,prices,variations&client_id=7422b4b7-e115-48b0-93bb-ba6dc8ee59fd&locale=${olaLocale}`;
      }
    }
    mergedParams.localeFacet = localeFacet;
    mergedParams.facetFilters = [{ 'facet': 'locale', 'facetValue': localeFacet }, {
      'facet': 'DTG_locale',
      'facetValue': localeFacet
    }];
    if (+mergedParams.product === 21849) {
      mergedParams.customer = 1570;
    }

    initConfigure(mergedParams);
  });

  // We want to tell users that navigate the page using a keyboard apart
  // from those that don't. ADA guidelines require showing an outline
  // when focusing elements with tabindex.
  document.addEventListener('keydown', function handleKeyDown(ev) {
    // Tab key pressed
    if (ev.keyCode === 9) {
      $('body').addClass('fc-tabbing-enabled');
      document.removeEventListener('keydown', handleKeyDown);
    }
  });

  // mergedParams has not been initialized yet, so we need to merge the params here
  const initParams = _.merge(params, configureParams, utils.parseUrlParams());
  globalBuild.setWorkflow(initParams.workflow);
  globalBuild.setCustomer(initParams.customer);

  globalBuild.requireScript(globalBuild.getPathForLocation('configure_ui_js_url', initParams.loc));
  const stylesToInclude = [
    globalBuild.getPathForLocation('configure_ui_css_url', initParams.loc)
  ];

  // When using Webpack Hot Model Replacement (HMR), the CSS is bundled in.
  if (!module.hot) {
    const cssPrefix = initParams.buildType === 'cdn' ? globalBuild.getPathForLocation('asset_path_cdn', initParams.loc) : process.env.asset_path;
    let fluidConfigureCSS = cssPrefix + '/css/' + process.env.css_file;
    if (location.href.indexOf('localhost') !== -1) {
      fluidConfigureCSS = fluidConfigureCSS.replace('.min.css', '.css');
    }
    stylesToInclude.push(fluidConfigureCSS);
  }

  globalBuild.requireConfigureStyles(stylesToInclude);
}());

performance.mark('configure:javascript:loaded');
fluidTimings.finish('Load JavaScript');
console.timeEnd('Load Configure JavaScript');
